<div *ngIf="load" class="load-details-container">
    <app-page-heading [key]="'local-loads.search.details.page-title'"></app-page-heading>

    <div class="load-details">
        <ng-container *ngFor="let stop of load.stops">
            <app-stop-details #stopElements [stop]="stop"></app-stop-details>
        </ng-container>

        <app-load-communication [loadUuid]="load.loadUuid" [communication]="load.communication" [noteTypes]="noteTypes" [carrier]="carrier"></app-load-communication>

        <app-load-events [events]="load.events"></app-load-events>

        <div class="text-right m-b-md">
            <button class="btn btn-warning m-r-md" (click)="openResetStatus(resetStatusModal)" *ngIf="canResetStatus">
                <i class="fa fa-history"></i>
                <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.reset-status'}]"></span>
            </button>
            <button class="btn btn-primary" (click)="getLoadDetails(true)">
                <i class="fa fa-sync-alt"></i>
                <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.refresh'}]"></span>
            </button>
        </div>
    </div>
</div>


<ng-template #resetStatusModal>
    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.modals.reset-status.body'}]"></span>
</ng-template>
